import { render, staticRenderFns } from "./CgCreditsMethod.vue?vue&type=template&id=2de039ef"
import script from "./CgCreditsMethod.vue?vue&type=script&lang=js"
export * from "./CgCreditsMethod.vue?vue&type=script&lang=js"
import style0 from "./CgCreditsMethod.vue?vue&type=style&index=0&id=2de039ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports